import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Customer } from 'app/models/customer.model';
import { CustomerService } from 'app/services/customer/customer.service';
import { EditCustomerComponent } from './edit-customer/edit-customer.component';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.css']
})
export class CustomersComponent implements OnInit {
  title = 'Clientes';
  customer: Customer;
  customers: Customer[];
  displayedColumns = ['customer', 'contact', 'number', 'actions'];
  customerDataSource: MatTableDataSource<Customer>;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private customerService: CustomerService, private dialog: MatDialog) { }

  ngOnInit(): void {
    this.getCustomers();
    this.customer = new Customer();
  }

  getCustomers(){
    this.customerService.getCustomers().subscribe(customers => {
      this.customers = customers;
      this.customerDataSource = new MatTableDataSource<Customer>(this.customers);
      this.customerDataSource.paginator = this.paginator;
      console.log('customers loaded!');
    });
  }

  openForm(){
    const dialogRef = this.dialog.open(EditCustomerComponent, {
      data: {
        id: this.customer.id,
        customerName: this.customer.customerName,
        name: this.customer.name,
        phone: this.customer.phone,
        mobile: this.customer.mobile
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('dialogo cerrado');
      this.ngOnInit();
    })
  }

  updateCustomer(customer: Customer){
    this.customer = customer;
    this.customer.id = customer.id;
    this.openForm();
  }

}
